var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.82726L10.8619 5.55648C11.1223 5.25894 11.5444 5.25894 11.8047 5.55648C12.0651 5.85403 12.0651 6.33644 11.8047 6.63398L8.4714 10.4435C8.21105 10.741 7.78895 10.741 7.5286 10.4435L4.19526 6.63398C3.93491 6.33644 3.93491 5.85403 4.19526 5.55648C4.45561 5.25894 4.87772 5.25894 5.13807 5.55648L8 8.82726Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.ec98a5e3.svg";
export { ForwardRef as ReactComponent };